module.exports = __webpack_public_path__ + "img/favourite_banner.915fd3a9.png";